import { render, staticRenderFns } from "./Meta.vue?vue&type=template&id=027afbaa&scoped=true&"
import script from "./Meta.vue?vue&type=script&lang=js&"
export * from "./Meta.vue?vue&type=script&lang=js&"
import style0 from "./Meta.vue?vue&type=style&index=0&id=027afbaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027afbaa",
  null
  
)

export default component.exports